export default "__VITE_ASSET__eIG$vQGN__"